import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4l0 16","key":"svg-0"}],["path",{"d":"M7 12h2l8 -8","key":"svg-1"}],["path",{"d":"M9 12l8 8","key":"svg-2"}]]

const IconLetterK = createReactComponent('outline', 'letter-k', 'LetterK', __iconNode);

export default IconLetterK;